module.exports = __webpack_public_path__ + "static/media/icon-date.698ad4bc.svg";